import { useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import BrandMark from '../components/BrandMark';
import { authApi } from '../api/authApi';

export default function PasswordResetPage({ mode = 'request' }) {
  const [params] = useSearchParams();
  const token = params.get('token');
  const initialMode = token ? 'reset' : mode;
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [busy, setBusy] = useState(false);
  const [msg, setMsg] = useState('');
  const [error, setError] = useState('');

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError('');
    setMsg('');
    try {
      if (initialMode === 'reset') {
        await authApi.resetPassword(token, password);
        setMsg('Password updated. You can now sign in.');
      } else {
        await authApi.forgotPassword(email.trim());
        setMsg('If that email is on file, a reset link is on its way.');
      }
    } catch (err) {
      setError(err.message || 'Something went wrong');
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="auth-shell">
      <div className="auth-card">
        <Link to="/" style={{ marginBottom: 24, display: 'inline-block' }}><BrandMark size={28} /></Link>
        <h2 className="h2">{initialMode === 'reset' ? 'Set a new password' : 'Reset your password'}</h2>
        <p className="muted" style={{ marginBottom: 18 }}>
          {initialMode === 'reset' ? 'Pick something memorable but strong.' : 'We\'ll send a link if the email matches an account.'}
        </p>
        <form onSubmit={submit}>
          {initialMode === 'reset' ? (
            <div className="form-row">
              <label className="label">New password</label>
              <input type="password" required minLength={8} value={password} onChange={(e) => setPassword(e.target.value)} />
            </div>
          ) : (
            <div className="form-row">
              <label className="label">Email</label>
              <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} />
            </div>
          )}
          {error ? <p className="error-text">{error}</p> : null}
          {msg ? <p style={{ color: 'var(--accent)', fontWeight: 700 }}>{msg}</p> : null}
          <button className="btn btn-primary btn-block btn-lg" disabled={busy}>
            {busy ? 'Working…' : (initialMode === 'reset' ? 'Update password' : 'Send reset link')}
          </button>
        </form>
        <p className="row" style={{ justifyContent: 'center', marginTop: 16, fontSize: 13 }}>
          <Link to="/login">Back to sign in</Link>
        </p>
      </div>
      <style>{`
        .auth-shell { min-height: 100vh; display: grid; place-items: center; padding: 32px 16px; }
        .auth-card { width: min(440px, 100%); background: var(--panel); border: 1px solid var(--line); border-radius: var(--radius-lg); padding: 28px; }
      `}</style>
    </div>
  );
}
